import { CustomerUtilsService } from 'src/app/features';
import {CashMovements, Items, Sales} from 'tilby-models';

type HistoryCustomFilterType = 'customer_name' | 'type_document' | 'printer' | 'payment_type' | 'sequential_number';

type ResultData<T> = {
    results: T[]
}

export class HistorySalesNormalizedData {
    static normalized(data: ResultData<Sales & Record<HistoryCustomFilterType, any>>) {
        for (const sale of data.results) {
            if (!sale) {
                continue;
            }

            sale.customer_name = CustomerUtilsService.getCustomerName(sale.sale_customer) || ''
            sale.payment_type = sale.payments?.map(payment => payment.payment_method_name).join(',');

            const firstSaleDocument = sale.sale_documents?.[0];

            if (firstSaleDocument) {
                sale.type_document = firstSaleDocument.document_type || '';
                sale.printer = firstSaleDocument.printer_name || '';
                sale.sequential_number = firstSaleDocument.sequential_number || '';
            } else if(sale.status === 'stored') {
                sale.type_document = 'stored_sale';
            }
        }

        return data;
    }
}

type HistoryCashMovementsCustomFilterType = 'movement_type' | 'movement_account';

export class HistoryCashMovementsNormalizedData {
    static normalized(data: ResultData<CashMovements & Record<HistoryCashMovementsCustomFilterType, any>>) {
        for (const element of data.results) {
            element.movement_type = element?.type || '';
            element.movement_account = element?.account || '';
        }
       return data;
   }
}


type ItemsCustomFilterType = 'category_name' | 'item_barcodes' | 'alternative_descriptions_value'
    | 'department_name' | 'department2_name' | 'department3_name' | 'department4_name' | 'department5_name'
    | 'department6_name' | 'department7_name' | 'department8_name' | 'department9_name' | 'department10_name';

export class ItemsNormalizedData {
    static normalized(data: Object & {results: (Items & Record<ItemsCustomFilterType, any>)[] }) {
        data.results?.forEach(element => {
            // console.log("Element: ", element)
            element.category_name = element?.category?.name || '';
            element.department_id = element?.department?.id || undefined;
            element.department_name = element?.department?.name || '';
            element.department2_id = element?.department2?.id || undefined;
            element.department2_name = element?.department2?.name || '';
            element.department3_id = element?.department3?.id || undefined;
            element.department3_name = element?.department3?.name || '';
            element.department4_id = element?.department4?.id || undefined;
            element.department4_name = element?.department4?.name || '';
            element.department5_id = element?.department5?.id || undefined;
            element.department5_name = element?.department5?.name || '';
            element.department6_id = element?.department6?.id || undefined;
            element.department6_name = element?.department6?.name || '';
            element.department7_id = element?.department7?.id || undefined;
            element.department7_name = element?.department7?.name || '';
            element.department8_id = element?.department8?.id || undefined;
            element.department8_name = element?.department8?.name || '';
            element.department9_id = element?.department9?.id || undefined;
            element.department9_name = element?.department9?.name || '';
            element.department10_id = element?.department10?.id || undefined;
            element.department10_name = element?.department10?.name || '';
            // element.alternative_descriptions_value = element?.alternative_descriptions?.filter(item => item.value).map(item => item.value).join(', '); 
            element.item_barcodes = element?.barcodes?.filter(item => item.barcode).map(item => item.barcode).join(', '); 
        });
        return data;
    }
}